<template>
	<div>
		<div v-on:click="toggleFileSettings();" class="btn-lg btn-dark text-white btn ml-0 mr-2 ">
			<i class="fas fa-share-alt"></i>
		</div>
	</div>
</template>

<script>
	export default {
		props: [
		'fileId',
		'BlockId'
		],
		data() {
			return {
			}
		},
		mounted: function() {
			// this.$root['FileSettingsFileId'] = this.fileId;
		},
		methods:{
			toggleFileSettings: function(){
				var formData = new FormData();
				this.$root['FileSettingsFileId'] = this.fileId;
				this.$root['FileSettingsBlockId'] = this.BlockId;

				formData.append('FileSettingsFileId', this.fileId);
				console.log( this.fileId )
				axios.post( '/manage/files/shared', formData)
				.then(function(data) {
					this.$root['FileSettingsShare'] = data.data;
					return this.$root['showFileSettings'] = ! this.$root['showFileSettings'];
				}.bind(this)).catch(function(data) {
					console.log('error', data);
				});
			}
		}
	};
</script>



// WEBPACK FOOTER //
// resources/js/components/ShareFileButton.vue